<mat-card>
  <form [formGroup]="constituency_register_form">
    <div class="form-group">
      <label>Name  <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control code_box" formControlName='name'>
    </div>
    <button mat-raised-button color="primary" (click)="registerConstituency()" [disabled]="!constituency_register_form.valid" class="capitalize">{{action}}</button>
  </form>
</mat-card>
